export default "__VITE_ASSET__PwRjdFxV__"